export default "__VITE_ASSET__D_NO_qKh__"